/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/alt-text */
import { CardUpload } from '@cannect/new-components/molecules'
import { message, Result } from 'antd'
import { NoToken } from 'assets/svg/result'
import LoadingContainer from 'components/LoadingContainer'
import Button from 'new-components/Button'
import { useEffect, useState } from 'react'
import { RiCheckFill, RiErrorWarningFill } from 'react-icons/ri'
import { verifyTypeById } from 'utils/validators'
import { getOrderB2c, getOrderCodB, handleSaveDocument } from './services/documentServices'
import StatusModal from './StatusModal'
import * as S from './styles'
import { DocumentTextBox, TextDocument } from './styles'
import { TEXTINPUTDATA } from './TextInput'
import { TipModal } from './TipModal'
import { DocumentTypes, PublicDocumentResponseTypes } from './types/documentTypes'

type DocumentsProps = {
  orderIdObject: any
  returnDocs: (data: any) => void
  noImportCost: boolean
  deliveryByAssociation: boolean
  showAnvisa: boolean
  showLaudoMedico: boolean
}

export function Documents({
  orderIdObject,
  returnDocs,
  noImportCost = false,
  deliveryByAssociation = false,
  showAnvisa = false,
  showLaudoMedico = false
}: DocumentsProps) {
  const order_id = orderIdObject
  const validateId = order_id && verifyTypeById(order_id.toString())
  const [documentsList, setDocumentsList] = useState({} as PublicDocumentResponseTypes)
  const [openTipModal, setOpenTipModal] = useState(false)
  const [loadingDocuments, setLoadingDocuments] = useState(false)
  const [statusModal, setStatusModal] = useState({
    error: false,
    isOpen: false
  })

  const [tipData, setTipData] = useState<DocumentTypes | null>(null)

  const requestType = async () => {
    if (validateId) {
      setLoadingDocuments(true)

      if (validateId?.type === 'UUID') {
        const data = await getOrderB2c({ order_uuid: validateId.order_id })
        if ('message' in data) {
          message.error(data.message)
        } else {
          setDocumentsList(data)
          returnDocs(data)
        }
      } else {
        const data = await getOrderCodB({ order_id: validateId.order_id })
        if ('message' in data) {
          message.error(data.message)
        } else {
          setDocumentsList(data)
          returnDocs(data)
        }
      }

      setLoadingDocuments(false)
    }
  }

  const handleUpload = async ({ file, type }: { file: File; type: DocumentTypes }) => {
    const uuid = validateId && validateId?.type === 'UUID' ? documentsList?.order_id : undefined

    try {
      const data = await handleSaveDocument({ uuid, order_id, file, type })

      if ('id' in data) {
        setDocumentsList((prevState) => ({
          ...prevState,
          [type]: [...(prevState[type] || []), data]
        }))
        returnDocs((prevState: any) => ({
          ...prevState,
          [type]: [...(prevState[type] || []), data]
        }))

        if (openTipModal) {
          setOpenTipModal(false)
        }

        setStatusModal({
          error: false,
          isOpen: true
        })

        return { success: true, data }
      }
      throw new Error('Erro ao processar arquivo, por favor, repita a operação.')
    } catch (error: any) {
      setStatusModal({
        error: true,
        isOpen: true
      })

      return { success: false, error }
    }
  }

  const handleShowTip = (type: DocumentTypes) => {
    setTipData(type)
    setOpenTipModal(true)
  }

  useEffect(() => {
    if (order_id) {
      requestType()
    }
  }, [order_id])

  if (!order_id) {
    return (
      <Result
        icon={<img src={NoToken} />}
        title="Nenhum token foi identificado, acesse a lista de pedidos e tente novamente."
        extra={
          <Button>
            Voltar para <strong>meus pedidos</strong>
          </Button>
        }
      />
    )
  }

  return (
    <S.Wrapper>
      <S.Heading>
        Envio de <span>documentos</span>
      </S.Heading>

      <DocumentTextBox>
        <TextDocument>
          Os documentos solicitados abaixo são exigidos pela Anvisa. Mas não se preocupe! Nesta etapa, apenas a
          prescrição médica é obrigatória. Caso não possa anexar os outros documentos agora, você poderá enviá-los após
          a finalização do pagamento
        </TextDocument>
      </DocumentTextBox>

      <StatusModal
        onClickButton={() =>
          setStatusModal({
            error: false,
            isOpen: false
          })
        }
        variant={statusModal.error ? 'error' : 'success'}
        icon={statusModal.error ? <RiErrorWarningFill /> : <RiCheckFill />}
        textButton={statusModal.error ? 'Tentar Enviar Novamente' : 'Continuar'}
        isOpen={statusModal.isOpen}
        onClose={() =>
          setStatusModal({
            error: false,
            isOpen: false
          })
        }
        title={statusModal.error ? 'Erro ao anexar o seu documento' : 'Documento anexado com sucesso'}
        text={
          statusModal.error ? (
            <div style={{ textAlign: 'left' }}>
              <p style={{ marginBottom: '12px' }}>
                Não foi possível processar o documento enviado. Isso pode ter ocorrido por um dos seguintes motivos:
              </p>
              <ul style={{ paddingLeft: '20px', marginBottom: '12px' }}>
                <li>
                  O tipo de documento enviado não corresponde ao solicitado (ex: documento de identidade enviado no
                  campo de comprovante de residência)
                </li>
                <li>O arquivo está protegido por senha</li>
                <li>O arquivo está corrompido ou ilegível</li>
                <li>Nossa IA não conseguiu interpretar o conteúdo do documento</li>
                <li>Ocorreu um erro interno no processamento</li>
              </ul>
              <p>Por favor, verifique se o documento está correto e legível, e tente enviá-lo novamente.</p>
            </div>
          ) : null
        }
      />

      {loadingDocuments ? (
        <LoadingContainer loading />
      ) : (
        <S.ContentUpload>
          {documentsList.RECEITA?.length === 0 && (
            <CardUpload
              buttonClasses="h-full w-full md:w-[86px] md:min-w-[86px] rounded-none md:p-0 py-2"
              showDescriptionFilesAccept
              currentFilesList={documentsList?.RECEITA}
              title={TEXTINPUTDATA.RECEITA.title}
              description={TEXTINPUTDATA.RECEITA.description}
              isRequired
              onUploadFile={(file) => handleUpload({ file, type: 'RECEITA' })}
            />
          )}
          {documentsList.IDENTIDADE?.length === 0 && (
            <CardUpload
              buttonClasses="h-full w-full md:w-[86px] md:min-w-[86px] rounded-none md:p-0 py-2"
              showDescriptionFilesAccept
              currentFilesList={documentsList?.IDENTIDADE}
              title={TEXTINPUTDATA.IDENTIDADE.title}
              description={TEXTINPUTDATA.IDENTIDADE.description}
              onUploadFile={(file) => handleUpload({ file, type: 'IDENTIDADE' })}
              customTrigger={documentsList.IDENTIDADE?.length === 0 ? () => handleShowTip('IDENTIDADE') : undefined}
            />
          )}
          {documentsList.RESIDENCIAL?.length === 0 && (
            <CardUpload
              buttonClasses="h-full w-full md:w-[86px] md:min-w-[86px] rounded-none md:p-0 py-2"
              showDescriptionFilesAccept
              currentFilesList={documentsList?.RESIDENCIAL}
              title={TEXTINPUTDATA.RESIDENCIAL.title}
              description={TEXTINPUTDATA.RESIDENCIAL.description}
              onUploadFile={(file) => handleUpload({ file, type: 'RESIDENCIAL' })}
            />
          )}

          {deliveryByAssociation && (
            <CardUpload
              buttonClasses="h-full w-full md:w-[86px] md:min-w-[86px] rounded-none md:p-0 py-2"
              showDescriptionFilesAccept
              currentFilesList={documentsList?.TERMO_AJUIZAMENTO}
              title={TEXTINPUTDATA.TERMO_AJUIZAMENTO.title}
              description={TEXTINPUTDATA.TERMO_AJUIZAMENTO.description}
              onUploadFile={(file) => handleUpload({ file, type: 'TERMO_AJUIZAMENTO' })}
            />
          )}

          {showLaudoMedico && (
            <CardUpload
              buttonClasses="h-full w-full md:w-[86px] md:min-w-[86px] rounded-none md:p-0 py-2"
              showDescriptionFilesAccept
              currentFilesList={documentsList?.LAUDO_MEDICO}
              title={TEXTINPUTDATA.LAUDO_MEDICO.title}
              description={TEXTINPUTDATA.LAUDO_MEDICO.description}
              onUploadFile={(file) => handleUpload({ file, type: 'LAUDO_MEDICO' })}
            />
          )}
          {/* {documentsList.VINCULO?.length > 0 && (
            <CardUpload
              buttonClasses="h-full w-full md:w-[86px] md:min-w-[86px] rounded-none md:p-0 py-2"
              showDescriptionFilesAccept
              currentFilesList={documentsList?.VINCULO}
              title={TEXTINPUTDATA.VINCULO.title}
              description={TEXTINPUTDATA.VINCULO.description}
              onUploadFile={(file) => handleUpload({ file, type: 'VINCULO' })}
              customTrigger={documentsList.VINCULO?.length === 0 ? () => handleShowTip('VINCULO') : undefined}
            />
          )} */}
          {showAnvisa && documentsList.ANVISA?.length === 0 && (
            <CardUpload
              buttonClasses="h-full w-full md:w-[86px] md:min-w-[86px] rounded-none md:p-0 py-2"
              showDescriptionFilesAccept
              currentFilesList={documentsList?.ANVISA}
              title={TEXTINPUTDATA.ANVISA.title}
              description={TEXTINPUTDATA.ANVISA.description}
              onUploadFile={(file) => handleUpload({ file, type: 'ANVISA' })}
              link="https://cannect-upload-homolog.s3.us-east-2.amazonaws.com/Documentos/Modelos/PASSO-A-PASSO-ANVISA.pdf"
              linkTitle="Solicitação anvisa"
            />
          )}
        </S.ContentUpload>
      )}

      {tipData && (
        <TipModal
          openTipModal={openTipModal}
          onCloseTip={() => setOpenTipModal(false)}
          type={tipData}
          onConfirmToUpload={(file) => handleUpload({ file, type: tipData })}
        />
      )}
    </S.Wrapper>
  )
}
